import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';


function HomePage() {
    return (
        <>
            <div>
                <div class='center'>
                    <Link  to='/properties'>Properties</Link>
                </div>
                <div class='center'>
                    <Link to='/tenants'>Tenants</Link>
                </div>
                <div class='center'>
                    <Link to='/residentmanager'>Resident Manager</Link>  
                </div>
                <div class='center'>
                    <Link to='/units'>Units</Link>
                </div>
                <div class='center'>
                    <Link to='/propertiesrms'>Properties_RMs</Link>
                </div>
            </div>
            
        </>
    );
}

export default HomePage;